import {CLONE_STATUS_NEW, TYPE_LIKERT} from "@irati/insights/constants/question"

const answers = [
  {
    text: "Strongly disagree",
    value: 1,
    contentId: "insights.answer.stronglyDisagree",
    __typename: "Answer"
  },
  {
    text: "Disagree",
    value: 2,
    contentId: "insights.answer.disagree",
    __typename: "Answer"
  },
  {
    text: "Neutral",
    value: 3,
    contentId: "insights.answer.neutral",
    __typename: "Answer"
  },
  {
    text: "Agree",
    value: 4,
    contentId: "insights.answer.agree",
    __typename: "Answer"
  },
  {
    text: "Strongly agree",
    value: 5,
    contentId: "insights.answer.stronglyAgree",
    __typename: "Answer"
  }
]

const question = {
  answers,
  contentId: null,
  driverUuid: null,
  driverId: null,
  tenantUuid: null,
  etag: null,
  groupUuids: [],
  status: CLONE_STATUS_NEW,
  text: null,
  type: TYPE_LIKERT,
  uuid: null,
  createdAt: null,
  __typename: "Question"
}

export default question
